<template>
	<footer class="bg-gray-900 text-white py-16">
		<div class="max-w-7xl mx-auto px-6">
			<div style="display: flex;justify-content: space-between;">
				<div>
					<div class="text-2xl font-['Pacifico'] text-white font-bold mb-4">义乌缕新</div>
					<p class="text-gray-400 mb-6">
						专注国际贸易，连接全球市场，为客户提供优质的产品和服务。
					</p>
					<div class="flex space-x-4">
						<a href="#" class="text-gray-400 hover:text-white transition-colors duration-200">
							<i class="fab fa-weibo fa-lg" style="width: 20px; height: 20px; display: flex; justify-content: center; align-items: center;"></i>
						</a>
						<a href="#" class="text-gray-400 hover:text-white transition-colors duration-200">
							<i class="fab fa-weixin fa-lg" style="width: 20px; height: 20px; display: flex; justify-content: center; align-items: center;"></i>
						</a>
						<a href="#" class="text-gray-400 hover:text-white transition-colors duration-200">
							<i class="fab fa-linkedin fa-lg" style="width: 20px; height: 20px; display: flex; justify-content: center; align-items: center;"></i>
						</a>
					</div>
				</div>
				<div>
					<h4 class="text-lg font-semibold mb-4">快速链接</h4>
					<ul class="space-y-2">
						<li><a href="/home" class="text-gray-400 hover:text-white transition-colors duration-200">网站首页</a></li>
						<li><a href="/about" class="text-gray-400 hover:text-white transition-colors duration-200">关于我们</a></li>
						<li><a href="/phoneUs" class="text-gray-400 hover:text-white transition-colors duration-200">联系我们</a></li>
						<li><a href="/shzpInfo" class="text-gray-400 hover:text-white transition-colors duration-200">社会招聘</a></li>
					</ul>
				</div>
				<div>
					<h4 class="text-lg font-semibold mb-4">联系方式</h4>
					<ul class="space-y-2 text-gray-400">
						<li>浙江省金华市义乌市城西街道义乌跨境电商产业园8幢1101室</li>
						<li>18957969555</li>
						<li>liufang@cunfang2016.com</li>
						<li>周一至周五 9:00-18:00</li>
					</ul>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import { getFooterData } from '@/api/index'

export default {
    name: 'Footer',

    data() {
        return {
            footerData: {
                phone: '123-456-7890',
                email: 'example@example.com',
                address: '默认地址',
                weChatImage: 'default-wechat-image.png',
                icp: '默认ICP',
                beianImage: 'default-beian-image.png',
                publicSecurity: '默认公安信息',
                copyright: '© 2023 默认版权'
            }
        };
    },

    mounted() {
        // 获取缓存的数据
        const cachedFooterData = localStorage.getItem('footerData');
        // 如果有缓存的数据，则使用缓存的数据
        if (cachedFooterData) {
            this.footerData = JSON.parse(cachedFooterData);
        } else {
            //this.fetchFooterData();
        }
    },

    methods: {
        // 获取Footer数据
        async fetchFooterData() {
            try {
                // 获取Footer数据
                const response = await getFooterData();
                // 如果请求成功，且数据不为空，则更新数据
                if (response.code === 0 && response.data.length > 0) {
                    this.footerData = response.data[0];
                    // 将数据缓存到localStorage
                    localStorage.setItem('footerData', JSON.stringify(this.footerData));
                } else {
                    console.error('Failed to fetch footer data:', response.message);
                }
            } catch (error) {
                console.error('Failed to fetch footer data:', error);
            }
        }
    },
};
</script>

<style scoped>
/* 额外的自定义样式 */
.rounded-button {
  border-radius: 4px;
}
</style>